import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M9 12h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15 12h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M19 6.3a9 9 0 0 1 1.8 3.9 2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 2.5-2 2.5c-.8 0-1.5-.4-1.5-1",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "Baby";
const Baby = memo(themed(Icon));
export {
  Baby
};
//# sourceMappingURL=baby.js.map
